import { get } from 'lodash';
import { GET_ALL_BENEFICIARIES_SUCCESS, SET_PAYEES } from './actions';

const reducer = (state = [], action) => {
	switch (action.type) {
		case GET_ALL_BENEFICIARIES_SUCCESS: {
			const beneficiaries = get(action, 'payload.beneficiaries', []);
			return [...beneficiaries];
		}
		case SET_PAYEES:
			return [...state, ...action.payees];
		default:
			return state;
	}
};

export default reducer;
